import { AccountRole } from 'src/types/userAuth';

/**
 * Where a dealer's Profile is: their profile in the dealer cabinet (a separate app; its route
 * `/dashboard/profile`), not the buyer's screen of the storefront (app#370, Tim's decision of
 * 2026-10-31). The cabinet holds the same session since the single sign-in (api#454), so it opens
 * signed in, with no second code.
 *
 * Null for anyone else — a visitor, a buyer, an account the api has not named yet — and when this
 * build names no cabinet: the storefront's own Profile then stays, rather than a link to its own
 * origin.
 */
export const dealerProfileUrl = (
  role: AccountRole | undefined,
  cabinetUrl: string | undefined
): string | null => {
  if (role !== AccountRole.DEALER) return null;

  const origin = (cabinetUrl ?? '').trim().replace(/\/+$/, '');

  return origin ? `${origin}/dashboard/profile` : null;
};
